export const PUBLICKEY = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEArCLWE9WdTws+I1AimwZg\n' +
  'gz3qWXAruoP6Y9CtybNq7EmUcnK0rouS2oyeOlxO4Btz+9P9uqeTZygFikzlO3sK\n' +
  'kOhLTEHVEhZIHWybkyDfStTNnbNo6ojPIKiZsYQiHB7QkX6Hie7+Y1Rq+i7eHmuG\n' +
  'IWrPNXZReADmdYQ/BQQLpu9O24o/U915ITwuE97v431tDn9H6V0B4xehUuZoltdu\n' +
  '3HbozP6DN+10/pNCjctMfjGyGyFqc/uRyc0qswWUSAsKbZtUvuiD8jKrw7hz/ST0\n' +
  'CnDfDyTy0d+Q64cf2SvHbIWKSlAsx0RzY7m87XJva5K5KeP1MSmRbltxZw8reZbg\n' +
  'OQIDAQAB';
export const PRIVATEKEY = 'MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQCsItYT1Z1PCz4j\n' +
  'UCKbBmCDPepZcCu6g/pj0K3Js2rsSZRycrSui5LajJ46XE7gG3P70/26p5NnKAWK\n' +
  'TOU7ewqQ6EtMQdUSFkgdbJuTIN9K1M2ds2jqiM8gqJmxhCIcHtCRfoeJ7v5jVGr6\n' +
  'Lt4ea4Yhas81dlF4AOZ1hD8FBAum707bij9T3XkhPC4T3u/jfW0Of0fpXQHjF6FS\n' +
  '5miW127cdujM/oM37XT+k0KNy0x+MbIbIWpz+5HJzSqzBZRICwptm1S+6IPyMqvD\n' +
  'uHP9JPQKcN8PJPLR35Drhx/ZK8dshYpKUCzHRHNjubztcm9rkrkp4/UxKZFuW3Fn\n' +
  'Dyt5luA5AgMBAAECggEAAJ6vfqrKQjqcIqxrM3u2ZUKX0XKh9a37/NgHiC5pOCib\n' +
  'rD3VgLtn7/mJqFQkxJHUvRdqVn27/icavgDA4pHy28q6Wq/yAHqsD88QUFtR8ocJ\n' +
  'poO64P1VIZz50LXVGZzSy3NVMZ32tIzdRcFdc2aXuQ8VZ+/hIzl9mva6812sXRGG\n' +
  'B98d0A/VXcnfF/9+e17AFhzeyUfTllP16Ask2eOutSRktSXul04OPHIqzYJf63Wa\n' +
  'IUtIsvsvVWJuMifpr4WJqMEGhX7p/lsCfmymwc/r5a4Nrku7uUjSS9BgMTAwD/ht\n' +
  'f6nksxoqA9s+Y9nBK8zWGkuBU6j6E1OZSFpiaB2yMQKBgQDZwVpOBGdRwVMm3icr\n' +
  'y+NNf1Tm0hDP/7egx0T0tjcDBj3G/12TX3Z/MmPWnwyNeidvbsp0a/xsahjJcaU7\n' +
  '+vr9ybqeOyZTW1IYGpu+7r2kjuYB0rW/bOZV65h6iUx6WF5DDYozHYYDia+GhbJ0\n' +
  'k1CiPdZuTrPjA95NhVAc/obSSwKBgQDKXl3YKvbGKFSLsL3A/DtBVbiXKiiKq3Vx\n' +
  'WsMxq/rkbxATHTS+xmhFhlLyysGI9V9Q4zZtEMzoAqwoNmkx3RdySi+ZvvJ4+ZXk\n' +
  'i6qcsGEeBEYiR+rXK/mvdoaA51MY1uBCzJ6HxQKmERTK6cM152/BFbLRjYUnlBAB\n' +
  'OOMdH9UlCwKBgDLSrgEHhhXOyVmJABt4utSbo3U8EjB5vqIH4FA9Nxm9my2W7IA5\n' +
  'B68oU6UD+ioLGKkpcpc5nPCw0pgxrh8RtQMG0kecBpXt+nslurQVhK2jrItAYqsK\n' +
  '/7eOBUiUQwVLGrULs/W6Lk0lFZKQIdaTi35ScHnOZK3XeUseklQyE8WBAoGABoJa\n' +
  'imV3YpBRh9y7fcWfMk7LjTEx9KPnNyowNRzPCSH5ZmP+GlTPbc0QRfb3mqwp0LQ+\n' +
  'P+vWa3AKkZCOeage5PI17cASlImSpLNJXZjextRkXR3rE9i6Q0aQtPy704S12fAy\n' +
  '+TMBDs5l2NEEEmvLUG6ePddLfSZqDWADDiDD/lkCgYEAt53KTrn4kr5QaK3c72B7\n' +
  '4LxENITRYwP2QRflbgU5xFaUiY84R214iDF1rISdKdeirgye/trxRnYq212KUm/g\n' +
  '2kYoHsZE/z4duK3j1eeviLItsq7ZcVOLmJEbbAnmgTkFtfxBQeSwfLBNdejvWAZ3\n' +
  'CtZlcw8QtrKZ0kpbI9qrg4g=';
export const pStr = 'nXI6GFRk/nfEsmtrYn0aHyld9bpzfVAVIwF5vJbEGf0KKEeP9EwoI8LOkUm8R6Dvnnz4kRqMRFrcNd19zsnrFXYuPy6IBe86wPC49dMOSVmPlDNl050eZwiPRQ8Jv08IeNNL//cEjMQAEXf6IvodLfgIB6IGKMyfM98sQPu88aYBH6GbZCLz4KNznZ1oF0gD3R6K5KKoBdIFFiy9ld+weqm1W8GS6OabQ1YtnYJPXd+wxHeFjD2b3JA3wHZphjmLbEoE9qzCaghwj+q+lG+SB84O23+L/OIn91lQw/NhB8ESrp9WhjKcHAisHXt4pLv9i943850aKdyPqagbr9J0hA==';
export const uStr = 'OA0WK13Pl4rRXdQZW4FEIOBbRmyEbPAQdhg4/lXdvHyPPzqG0L5BUDDJQiqwA2ia6s5iyUSFe8cSSGTnv4dGkqPol+NShbqw+D+CWdNnBKqF0KML07EdpebHab7q+8ez6PuzIzeRG7YMv2Xyp3mXZCLxr7yMb7TKwlLPmFngLEYlJD1jJX5C74g7o4rOHPugJ0hacs/bgc1CD4kGh85wA9XS3nu/gc+lAvHt17nwajzG/1thixdxdH2zURH4HrG89lcQltzhDl9eOj4uoSzpiTpM390XSACVkp+L1lctpPWR4gFZm+rzv8CX70UEUZYqZQe+kYmfC/j2KOrOnF71BA==';
// 本地记住密码使用
export const encryptionKey = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAzP9HbPGajsXC5gVN1usv\n' +
  'omFukx4sOFlS1Vhme8kkmunOjfZgTQhdUAjhoIVQ2JlstkZmcxBeS5QC3aUBTSvD\n' +
  '5p1ZozJBpTmNFZ4QNgeS2AKKuKKt2cZARPpp3mbO7XxCi4STphY/GcIPBZ2YW19F\n' +
  '2PbhXW5WrLuS/bl3ppvFDkpGg0syddrXwJXUGXQ8SfUtSRMiNZgxQfvJl1SX/DY4\n' +
  '2UzgPLc0w9j/mGXlU/c77kFsjDLp56QnBJycft+5toOjHrAkqIQPPnVDSbh8hKY6\n' +
  '4FyLLXCd+dd7e6znBP45kw2JcG8qtD2SN8MrCTXj/novSlkBE9rEzxfNLzA9H2MO\n' +
  'ZQIDAQAB';
// 本地记住密码解密使用
export const decryptKey = 'MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQDM/0ds8ZqOxcLm\n' +
  'BU3W6y+iYW6THiw4WVLVWGZ7ySSa6c6N9mBNCF1QCOGghVDYmWy2RmZzEF5LlALd\n' +
  'pQFNK8PmnVmjMkGlOY0VnhA2B5LYAoq4oq3ZxkBE+mneZs7tfEKLhJOmFj8Zwg8F\n' +
  'nZhbX0XY9uFdblasu5L9uXemm8UOSkaDSzJ12tfAldQZdDxJ9S1JEyI1mDFB+8mX\n' +
  'VJf8NjjZTOA8tzTD2P+YZeVT9zvuQWyMMunnpCcEnJx+37m2g6MesCSohA8+dUNJ\n' +
  'uHyEpjrgXIstcJ3513t7rOcE/jmTDYlwbyq0PZI3wysJNeP+ei9KWQET2sTPF80v\n' +
  'MD0fYw5lAgMBAAECggEAb7l5rhCHUeTKch7V65pGXdOINjotk5BrKseBI1nez2c6\n' +
  'IfjzR0iVwrb0cU33X/VOYJFB6Ng07DAA19fEO9DsddWwMteDG4+gKvX4k9nQ2FWa\n' +
  'UUKoSZZZFL790C5r/NbKVcutxMk/HsS69y6LCNGF+dejwA4Qwxd/5zSb13vyC/TJ\n' +
  'csdNtQmjqWZW+7MVa43n1UJd+wpGKzdrxdOmW2JJeMZpYEwcTHoIu3PSvZCzbnDH\n' +
  '9tsyiFrGSDzHN/PTQ7RfKHWLLIL6jgEeYz9NUvYaNni6GO6V6E0mgmMkbS9fwPk0\n' +
  'Hb7V4+29+ctBPuWOC139qJf08L5Xf15BSiiXBeUXQQKBgQDp2rg1auXaf99puhcP\n' +
  'WPX+JSKmS40vsdV8tXf+Z42ikN0ACZ/o2XRX31RSvexhv3q0330/dsLxCXS2vVHS\n' +
  'tsHwqpfSrDFPau4yHkwMYizgpzTB5+NRxjZmL/3Znhfn9SRpnnOyUgfXpTp9HcBV\n' +
  'Qd1JXeSg8YYUpBxoKnsni9TuCQKBgQDgaPscYCbTSclKlAr1iLB9+MqEcpAi6Kdg\n' +
  'H+Qqz39BKDMVALkkqdtZvzMoL3f5R8nW6YIfjp1NwTj1nn+7KuCf8RKTIrXACMSw\n' +
  'NVhk8AGfSGaNjnsk54i5GXGfho08yUtZ00BSTkJFrYRXyFknduAP8sAM/SqksCMV\n' +
  'B2OG28k0fQKBgGbrfsTrrgty2bWjU8DKa0EVwOElQRbrkkSXbR8HHhuc29bHZZxK\n' +
  'D90Yifj8Y0tFxVBTR8ElmHgSrE48lgVBr6smuTjb1bvZGMnv8ZJFpvCcRijM0IvN\n' +
  'y2U/293pqSXKCuN8+/hQB+mNa2djL6GWIjjG3PdENLli3KmvgJIQBX9ZAoGBALYq\n' +
  'gi12oA3ER/KSWpMWcq7P1xXNKdQsqDIPsVhPOC3cRBs4ixKID9e6rfxhDDL/Y4lh\n' +
  '5I9ZZbhIscQw9d8p3032k+18r61DcObZZvgJHEgArb8bejtq+EHJtcKZpu1BOjmg\n' +
  'kwY9IO8O+++GY1j11s0bcWsZ2BP4J4JajSBcKejBAoGAJf0QCD4olePDfhr7BPDF\n' +
  '2irZQPHSdJlSOWONVw+6sWVOn54VplrzwOX50zPb902pXxNqgs5iAlhrP2qJX2LN\n' +
  'plj/7o0hD5bzScml2xbatxl3rHdSNWxuu1zx2oRBSxLXbwA8a03uUXAXFFbB1gwd\n' +
  'a2nCSY12L5ZjrD5XJAM9K4Q=';
